// List of professions for dropdown
export const professions = [
  'Business Coach',
  'Life Coach',
  'Career Coach',
  'Health & Fitness Coach',
  'Financial Coach',
  'Executive Coach',
  'Leadership Coach',
  'Sales Trainer',
  'Digital Marketing Coach',
  'Real Estate Coach',
  'Relationship Coach',
  'Mindfulness Coach',
  'Productivity Coach',
  'Public Speaking Coach',
  'Entrepreneur',
  'Consultant',
  'Course Creator',
  'Author/Writer',
  'Speaker',
  'Therapist/Counselor',
  'Nutritionist/Dietitian',
  'Personal Trainer',
  'Yoga Instructor',
  'Music Teacher',
  'Language Teacher',
  'Academic Tutor',
  'Stock Market Trainer',
  'Cryptocurrency Coach',
  'E-commerce Specialist',
  'Social Media Expert',
  'Content Creator',
  'Photographer',
  'Graphic Designer',
  'Web Developer',
  'Software Developer',
  'IT Consultant',
  'HR Consultant',
  'Legal Advisor',
  'Real Estate Agent',
  'Insurance Advisor',
  'Other'
];